import React from 'react';

/**
 * Page wrapper for route content. Nav/Footer live in AppShell globally.
 */
const Layout = ({ children }) => <>{children}</>;

export default Layout;
